import {
  maxAgentsTier,
  resolveAgentsTier,
  type AgentsTier,
} from "@hightouch/lib/llm/agents-tier";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useEntitlements } from "src/hooks/use-entitlement";
import { useOrganizationEntitlement } from "src/hooks/use-organization-entitlement";

export function useAgentsTier(): AgentsTier {
  const { dataAgents } = useFlags();
  // Two reads of the tier, deliberately. The server's is the only one that sees
  // a staff grant from the Entitlement Center, at either tier — grants live in
  // `entitlement_grants`, which the org entitlements jsonb knows nothing about.
  // The jsonb read is synchronous, so it keeps the hook answering correctly
  // before the query resolves rather than reporting "off" and bouncing users
  // out of the agent routes on first render.
  const hasOrgEntitlement = useOrganizationEntitlement("dataAgents");
  const { data } = useEntitlements(true);

  // No source downgrades another — matches the backend's max-of-sources
  // semantics in getWorkspaceAgentsTier. The org entitlement confers full.
  return maxAgentsTier(
    maxAgentsTier(resolveAgentsTier(dataAgents), data.agentsTier),
    hasOrgEntitlement ? "full" : "off",
  );
}
